import { z } from 'zod';

export const ZodMdlrPaymentStatus = z.enum([
  'reprocessing',
  'cancelled',
  'void',
  'returned',
  'held',
  'unallocated',
  'submitted',
  'screening_req',
  'validated',
  'pending_for_date',
  'pending_for_funds',
  'ext_proc',
  'processed',
  'reconciled',
  'er_invalid',
  'er_extconn',
  'er_extsys',
  'er_expired',
  'er_general',
  'er_batch',
  'ext_sent',
  'clearing',
  'held_in_suspense',
  'shares_canceled',
]);

export type MdlrPaymentStatus = z.infer<typeof ZodMdlrPaymentStatus>;

export const ZodMdlrPaymentType = z.enum(['beneficiary', 'account', 'scan', 'iban', 'intl']);

export type MdlrPaymentType = z.infer<typeof ZodMdlrPaymentType>;
